import {
  CompanySurveyQuestionnaire,
  CompanySurveyQuestionnaireClass,
  CompanySurveyQuestionnaireJSONClass,
  SurveyDemographicQuestions,
} from '../types/SurveyQuestionnaireTypes';

import {ApiSerializer} from '../../../../../serializers/ApiSerializer';
import {serializeKey} from '../../../../../utils/serializer/serialize';

export const serializeDemographicQuestionId = (id: string): string =>
  id.includes('_') ? serializeKey('CamelCase', id) : id;

const toSurveyDemographicQuestions = (
  surveyDemographic: SurveyDemographicQuestions | undefined
): SurveyDemographicQuestions => ({
  questions: (surveyDemographic?.questions ?? []).map((question) => ({
    ...question,
    id: serializeDemographicQuestionId(question.id),
  })),
});

export default class QuestionnaireSerializer {
  static toQuestionnaire(questionnaire: CompanySurveyQuestionnaire): CompanySurveyQuestionnaire {
    return {
      ...questionnaire,
      surveyDemographic: toSurveyDemographicQuestions(questionnaire.surveyDemographic),
    };
  }

  static toGenerateResponse(data: CompanySurveyQuestionnaireJSONClass): CompanySurveyQuestionnaireClass {
    if (!data?.company_survey_questionnaire) {
      throw new Error('Missing company_survey_questionnaire in questionnaire API response');
    }

    const camelCased = ApiSerializer.toCamelCase<CompanySurveyQuestionnaireClass>(data);

    if (!camelCased?.companySurveyQuestionnaire) {
      throw new Error('Failed to parse company_survey_questionnaire from questionnaire API response');
    }

    return {
      companySurveyQuestionnaire: QuestionnaireSerializer.toQuestionnaire(camelCased.companySurveyQuestionnaire),
    };
  }
}
